import React, { Component } from 'react';

import { SectionTitle, BoxContentCases }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';

const cases = [
    {col: 'col-12 col-md-4 col-lg-4', img:'case-one', title: 'MONTAGEM TORRE PROMISSÃO', client: '', maker: 'São Paulo - SP', category: 'Torre Metálica'},
    {col: 'col-12 col-md-4 col-lg-4', img:'case-two', title: 'TORRE CASA BRANCA', client: 'John Doe', maker: 'São Paulo - SP', category: 'Torre Metálica'},
    {col: 'col-12 col-md-4 col-lg-4', img:'case-tree', title: 'MONTAGEM TORRE AUTOPORTANTE', client: 'John Doe', maker: 'Taquaritinga - SP', category: 'Torre Metálica'},

    
];

const brands = [
    {title: 'State Grid', logo: 'state-grid'},
    {title: 'CPFL Energia', logo: 'cpfl-energia'},
    {title: 'Cemig', logo: 'cemig'},    
    {title: 'Neoenergia', logo: 'neoenergia'},    
    {title: 'Enel', logo: 'enel'},
    {title: 'Celesc', logo: 'celesc'},
    {title: 'Copel', logo: 'copel'},
];

class Cases extends Component {
    render() {
        return (
            <section className={isMobile ? 'home-cases-mobile' : 'home-cases'} id="cases">
                <div className="container">
                    {SectionTitle({section: 'Casos de Sucesso', subtitle:'CONFIRA ALGUNS DE NOSSOS', featured: 'CASOS DE SUCESSO'})}
                    <div className="row">
                        {cases.map((item,key) => { return BoxContentCases(item,key) } )}
                    </div>                 
                </div>                 
                <div className="container mt-50">
                    {SectionTitle({section: 'Clientes', subtitle:'VEJA ABAIXO ALGUNS DE NOSSOS', featured: 'CLIENTES'})}
                    <div className="row">
                    {
                        brands.map((item, i) => (
                            <div className="col-3 col-md-2 grayscale mb-25" key={i}>
                                <picture>
                                    <img srcSet={process.env.PUBLIC_URL +'/assets/images/logo-'+item.logo+'.jpg'} src="" alt={item.logo} title={item.title} className="img-fluid" />
                                </picture>
                            </div>                                    
                        ))
                    }  
                    </div>
                </div>
            </section>
        )
    }
}

export default Cases;
